<template>
  <gmap-map
    ref="mapRef"
    :center="center"
    :zoom="14"
    map-type-id="roadmap"
    :options="{
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      gestureHandling: 'greedy',
    }"
    :style="{ height: height, width: '100%' }"
  >
    <gmap-polygon
      v-for="p in polygons"
      :key="p.pk"
      :paths="p.paths"
      :options="polygonOptions(p)"
      @click="$emit('field-click', p.pk)"
    />
  </gmap-map>
</template>

<script>
/* global google */
import { resolveFieldPolygons } from '@/lib/field-set-filter'

/**
 * 圃場ポリゴンを表示する共用マップ。
 * - fields: ストアの圃場配列 (geoJson を持つもの)
 * - highlightedPks: 強調表示する圃場 pk の配列 (String)。空なら全て通常色
 * クリックで field-click(pk) を emit する。
 */
export default {
  name: 'FieldsMapComponent',
  props: {
    fields: { type: Array, default: () => [] },
    highlightedPks: { type: Array, default: () => [] },
    height: { type: String, default: '420px' },
  },
  data() {
    return {
      center: { lat: 36.2048, lng: 138.2529 }, // 圃場がない場合のフォールバック (日本中心)
    }
  },
  computed: {
    polygons() {
      return resolveFieldPolygons(this.fields).map(m => ({
        pk: m.field_id,
        name: m.field_name,
        paths: m.polygon.coordinates[0].map(c => ({ lat: c[1], lng: c[0] })),
      }))
    },
    highlightedSet() {
      return new Set(this.highlightedPks.map(String))
    },
  },
  watch: {
    polygons() {
      this.fitBounds()
    },
    highlightedPks() {
      this.fitBounds()
    },
  },
  mounted() {
    this.fitBounds()
  },
  methods: {
    polygonOptions(p) {
      const highlighted = this.highlightedSet.has(String(p.pk))
      return {
        strokeColor: highlighted ? '#2E7D32' : '#9E9E9E',
        strokeWeight: highlighted ? 3 : 1,
        fillColor: highlighted ? '#66BB6A' : '#BDBDBD',
        fillOpacity: highlighted ? 0.55 : 0.25,
        clickable: true,
        zIndex: highlighted ? 2 : 1,
      }
    },
    fitBounds() {
      const targets = this.highlightedSet.size
        ? this.polygons.filter(p => this.highlightedSet.has(String(p.pk)))
        : this.polygons
      if (!targets.length || !this.$refs.mapRef) {
        return
      }
      this.$refs.mapRef.$mapPromise.then(map => {
        const bounds = new google.maps.LatLngBounds()
        targets.forEach(p => p.paths.forEach(pt => bounds.extend(pt)))
        map.fitBounds(bounds, 32)
      })
    },
  },
}
</script>
